import { useContext } from 'react';
import { ShiftContext } from './components/Context';
import { ShiftContextState } from './types';

export const useShift = (): ShiftContextState => {
  const context = useContext(ShiftContext);

  if (context === undefined) {
    throw Error('ShiftContext must be used inside ShiftContext Provider scope');
  }

  return context;
};
